import React, {useEffect} from 'react'
import MenuItem from '@material-ui/core/MenuItem'

export type ExportEventMenuItemBaseProps = {
  label: string
  ariaLabel: string
  onExport: () => void
  processing: boolean
  errorMessage: string | null
  successMessage: string | null
  setError: (error: string | null) => void
  setSuccess: (success: string | null) => void
}

const ExportEventMenuItemBase = React.forwardRef<
  HTMLLIElement,
  ExportEventMenuItemBaseProps
>((props, ref) => {
  const {
    label,
    ariaLabel,
    onExport,
    processing,
    errorMessage,
    successMessage,
    setError,
    setSuccess,
  } = props

  useEffect(() => {
    setError(errorMessage)
    setSuccess(successMessage)
  }, [errorMessage, successMessage, setError, setSuccess])

  return (
    <MenuItem
      disabled={processing}
      onClick={onExport}
      aria-label={ariaLabel}
      ref={ref}
    >
      {label}
    </MenuItem>
  )
})

ExportEventMenuItemBase.displayName = 'ExportEventMenuItemBase'

export default ExportEventMenuItemBase
